import { SliderWithNumberBox } from './SliderWithNumberBox';
import { Table } from './Table';
import { RadioGroup } from './RadioGroup';
import { Input, TextArea } from './Input';
import { Select } from './Select';
import { InputNumber } from './InputNumber';
import { ArrayItems } from './ArrayItems';
export const FormComMap = {
  SliderWithNumberBox,
  Table,
  RadioGroup,
  Select,
  Input,
  TextArea,
  InputNumber,
  ArrayItems
};
//# sourceMappingURL=es/components/FormComMap.js.map